import React from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

import { withUserConfig } from 'shared'
import { actions as LKModalActions, selectors as LKModalSelectors } from '../shared/LKModal'
import { getSession } from '../../store/auth'

import NoActivityWarning from './NoActivityWarning'
import ActivityTimeout from './ActivityTimeout'

// TODO: needs refactoring
@withRouter
@withUserConfig('IdleLock as activityTimeout')
@connect(
  (state) => ({
    warningOpen: LKModalSelectors.isOpen(state, 'NoActivityWarning'),
    session: getSession(state),
  }),
  {
    open: LKModalActions.open,
    close: LKModalActions.close,
  },
)
class UserNoActivityNotification extends React.Component {
  componentDidMount() {
    this.startTimeout()

    window.addEventListener('mousemove', this.handleUserInteraction)
    window.addEventListener('focus', this.handleUserInteraction)
  }

  componentDidUpdate() {
    if (!this.props.session.isAuthed) {
      this.clearTimeouts()
      this.removeEventListeners()
    }
  }

  componentWillUnmount() {
    this.clearTimeouts()
    this.removeEventListeners()
  }

  handleUserInteraction = () => {
    this.clearTimeouts()
    this.startTimeout()

    if (this.props.warningOpen) {
      this.props.close('NoActivityWarning')
    }
  }

  removeEventListeners = () => {
    window.removeEventListener('mousemove', this.handleUserInteraction)
    window.removeEventListener('focus', this.handleUserInteraction)
  }

  clearTimeouts = () => {
    clearTimeout(this.activityTimeout)
    clearTimeout(this.noActivityWarningTimeout)
  }

  startTimeout = () => {
    if (this.props.activityTimeout && this.props.activityTimeout !== 0) {
      const activityTimeoutInMS = this.props.activityTimeout * 1000

      this.noActivityWarningTimeout = setTimeout(() => {
        this.props.open({ name: 'NoActivityWarning' })
      }, activityTimeoutInMS - 30 * 1000)

      this.activityTimeout = setTimeout(() => {
        this.clearTimeouts()
        this.removeEventListeners()

        this.props.close('NoActivityWarning')
        this.props.open({ name: 'ActivityTimeout' })
      }, activityTimeoutInMS)
    }
  }

  render() {
    return (
      <>
        <NoActivityWarning />
        <ActivityTimeout />
      </>
    )
  }
}

export default UserNoActivityNotification
